import z from "zod";

import { DocumentMetadataSchema } from "../api-types";
import { type Env } from "../http/Env";
import { graphqlRequest } from "./graphqlRequest";

export interface MutationSaveCanvasMetadataRequestOptions {
	canvasID: string;
	title: string;
	owner: string;
	isTemplate: boolean;
	organizationID: string;
	archived: boolean;
	pages: { id: string; title: string; archived: boolean; parentPageID: string | null }[];
	version: number;
	env: Env;
	fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
	authorizationHeader: string | undefined;
}

export function mutationSaveCanvasMetadata({
	canvasID,
	title,
	owner,
	isTemplate,
	organizationID,
	archived,
	pages,
	version,
	env,
	fetch,
	authorizationHeader,
}: MutationSaveCanvasMetadataRequestOptions): Promise<MutationSaveCanvasMetadataResponse> {
	return graphqlRequest({
		env,
		fetch,
		authorizationHeader,
		query: mutationSaveCanvasMetadataOperation(
			canvasID,
			title,
			owner,
			isTemplate,
			organizationID,
			archived,
			pages,
			version
		),
		responseSchema: mutationSaveCanvasMetadataResponse,
		additionalHeaders: {
			"moment-operationName": "SaveCanvasMetadata",
			"moment-canvasID": canvasID,
			"moment-version": version.toString(),
		},
	});
}

export type MutationSaveCanvasMetadataResponse = z.infer<typeof mutationSaveCanvasMetadataResponse>;
const mutationSaveCanvasMetadataResponse = z.object({
	saveCanvasMetadata: DocumentMetadataSchema,
});

const mutationSaveCanvasMetadataOperation = (
	id: string,
	title: string,
	owner: string,
	isTemplate: boolean,
	organizationID: string,
	archived: boolean,
	pages: { id: string; title: string; archived: boolean; parentPageID: string | null }[],
	version: number
) => ({
	operationName: "SaveCanvasMetadata",
	query: `
	mutation SaveCanvasMetadata($metadata: CanvasMetadataInput!) {
		saveCanvasMetadata(metadata: $metadata) {
			type
			id
			title
			owner
			organizationID
			created
			updated
			updatedBy
			archived
			isTemplate
			pinnedAt
			archivedAt
			pagesMetadata {
			  id
			  title
			  slug
			  authorID
			  updated
			  created
			  canvasID
			  archived
			  parentPageID
			}
			atlasUserToken
			latestVersion
		}
	}`,
	variables: {
		metadata: {
			id,
			title,
			owner,
			isTemplate,
			organizationID,
			archived,
			pages,
			version,
		},
	},
});
